import {
  Button,
  DropdownMenu,
  icons,
  RawLink,
  Switch,
} from '@portal/components'
import React from 'react'

import { useStrictModeSetting } from '../../store'

const { SettingsSlider } = icons

export default function StrictModeToggle() {
  const { enabled, toggleEnabled } = useStrictModeSetting()

  return (
    <>
      <DropdownMenu>
        <DropdownMenu.Trigger asChild>
          <Button
            variant="outline"
            size="square"
            data-testid="strictModeToggle"
          >
            <SettingsSlider className="size-4" />
          </Button>
        </DropdownMenu.Trigger>

        <DropdownMenu.Content className="w-[275px] rounded-xl p-4" align="end">
          <div className="mb-2 flex flex-row items-center justify-between">
            <span className="text-lg leading-none">Strict mode</span>
            <Switch checked={enabled} onCheckedChange={toggleEnabled} />
          </div>
          <p className="mb-0 text-foreground-subtle">
            Strict mode returns REGISTERs by default.{' '}
            <RawLink
              href="https://docs.ditto.live/dql/strict-mode"
              isBlank
              className="text-foreground-normal underline"
            >
              Learn more in the docs.
            </RawLink>
          </p>
        </DropdownMenu.Content>
      </DropdownMenu>
    </>
  )
}
